import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { WorkflowPage } from 'src/shared/models/workflow-page.model';

@Component({
    selector: 'smt-staffing-plan-page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent implements OnInit {
    @Input() currentPage: WorkflowPage;
    @Input() isFormValid: boolean;

    @Output() doneClicked = new EventEmitter();
    @Output() nextClicked = new EventEmitter();
    @Output() previousClicked = new EventEmitter();
    @Output() skipClicked = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    done() {
        this.doneClicked.emit();
    }

    next() {
        this.nextClicked.emit();
    }

    previous() {
        this.previousClicked.emit();
    }

    skip() {
        this.skipClicked.emit();
    }
}
